import { render, staticRenderFns } from "./GanttChart.vue?vue&type=template&id=37c5403d&scoped=true"
import script from "./GanttChart.vue?vue&type=script&lang=js"
export * from "./GanttChart.vue?vue&type=script&lang=js"
import style0 from "./GanttChart.vue?vue&type=style&index=0&id=37c5403d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c5403d",
  null
  
)

export default component.exports